import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turnos-target-filter"
export default class extends Controller {
  static targets = ["tipoRadio", "autocompleteHost", "targetInput", "targetHidden", "results", "targetLabel"]

  connect() {
    this.applyFilterForCurrentTipo({ resetSelection: false })
  }

  tipoChanged() {
    this.applyFilterForCurrentTipo({ resetSelection: true })
  }

  applyFilterForCurrentTipo({ resetSelection }) {
    const tipo = this.currentTipoAtencion()
    if (!tipo || !this.hasAutocompleteHostTarget || !this.hasTargetInputTarget || !this.hasTargetHiddenTarget) return

    const url = new URL("/turnero/turnos/autocomplete_target", window.location.origin)
    url.searchParams.set("tipo_atencion", tipo)

    this.autocompleteHostTarget.setAttribute("data-autocomplete-url-value", `${url.pathname}${url.search}`)
    this.targetInputTarget.placeholder = this.placeholderFor(tipo)

    if (this.hasTargetLabelTarget) {
      this.targetLabelTarget.textContent = this.labelFor(tipo)
    }

    this.notifyTipoChanged(tipo)

    if (!resetSelection) return

    this.targetInputTarget.value = ""
    this.targetHiddenTarget.value = ""

    if (this.hasResultsTarget) {
      this.resultsTarget.innerHTML = ""
    }

    this.targetHiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.targetHiddenTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.targetInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  currentTipoAtencion() {
    const selected = this.tipoRadioTargets.find((radio) => radio.checked)
    return selected ? selected.value : null
  }

  placeholderFor(tipo) {
    return tipo === "imagenes" ? "Buscar servicio..." : "Buscar profesional..."
  }

  labelFor(tipo) {
    return tipo === "imagenes" ? "Servicio" : "Profesional"
  }

  notifyTipoChanged(tipo) {
    this.element.dispatchEvent(
      new CustomEvent("turnos-target-filter:tipo-changed", {
        bubbles: true,
        detail: { tipo }
      })
    )
  }
}
